'use client';

import { Link, usePathname } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import CourseIcon from '../icon/course-icon';
import HomeIcon from '../icon/home-icon';
import MyCourseIcon from '../icon/mycourse-icon';
import ProfileIcon from '../icon/profile-icon';
import { useMyClassRoute } from '@/hooks/use-my-class-route';

export default function BottomNav() {
  const t = useTranslations();
  const { isMyClassRoute, pathName } = useMyClassRoute();

  if (isMyClassRoute) return null;

  return (
    <section className="flex fixed bottom-0 left-0 z-50 justify-around py-3 w-full bg-white md:hidden">
      <Link
        href="/"
        className={`flex flex-col items-center ${'/' === pathName ? 'text-primary' : 'text-gray-500'}`}
      >
        <HomeIcon />
        <span>{t('navigation.home')}</span>
      </Link>

      <Link
        href="/courses"
        className={`flex flex-col items-center ${'/courses' === pathName ? 'text-primary' : 'text-gray-500'}`}
      >
        <CourseIcon />
        <span>{t('navigation.courses')}</span>
      </Link>

      <Link
        href="/my-classes"
        className={`flex flex-col items-center ${'/my-classes' === pathName ? 'text-primary' : 'text-gray-500'}`}
      >
        <MyCourseIcon />
        <span>{t('navigation.myClasses')}</span>
      </Link>

      <Link
        href="/profile"
        className={`flex flex-col items-center ${'/profile' === pathName ? 'text-primary' : 'text-gray-500'}`}
      >
        <ProfileIcon />
        <span>{t('navigation.profile')}</span>
      </Link>
    </section>
  );
}
